// extracted by mini-css-extract-plugin
module.exports = {"mainGame":"Game_mainGame__2NWD8","gameAside":"Game_gameAside__25FNq"};